import React from 'react';
import './Recipe.css';
import Section from '../common/Section';

export default function Recipe() {
  return (
    <Section title="[ RECIPES ]" link="/recipes" contentClassName="recipe-content">
    </Section>
  );
}
